{
  "electricityConsumption": "rgb(54, 121, 255, 0.8)",
  "electricityConsumptionOffPeak": "rgb(0, 84, 217, 0.8)",

  "electricityConsumptionReactive": "rgb(175, 54, 255, 0.8)",
  "electricityConsumptionReactiveOffPeak": "rgb(137, 0, 217, 0.8)",

  "electricityIntermediateConsumption": "rgb(0, 84, 217, 0.8)",
  "electricityIntermediateConsumptionReactive": "rgb(175, 54, 255, 0.8)",

  "electricityFeedIn": "rgb(7, 205, 117, 0.8)",
  "electricityFeedInOffPeak":  "rgb(0, 144, 56, 0.8)",

  "electricityFeedInReactive": "rgb(175, 54, 255, 0.8)",
  "electricityFeedInReactiveOffPeak": "rgb(137, 0, 217, 0.8)",

  "electricityGrossProduction": "rgb(0, 92, 67, 0.9)",
  "electricityGrossProductionReactive": "rgb(175, 54, 255, 0.8)",

  "electricityPower": "rgb(122, 167, 255, 0.8)",
  "electricityFeedInPower": "rgb(119, 201, 142, 0.8)",

  "gasConsumption": "rgb(255, 171, 0, 0.8)",
  "gasConsumptionPerHdd": "rgb(255, 171, 0, 0.8)",
  "gasConsumptionUncorrected": "rgb(173, 119, 7, 0.8)",
  "gasPower": "rgb(255, 201, 94, 0.8)",

  "waterConsumption": "rgb(0, 184, 217, 0.8)",
  "waterIntermediateConsumption": "rgb(0, 184, 217, 0.8)",
  "waterPower": "rgb(112, 234, 255, 0.8)",

  "heatConsumption": "rgb(241, 81, 46, 0.8)",
  "heatConsumptionPerHdd": "rgb(241, 81, 46, 0.8)",
  "heatPower": "rgb(235, 127, 103, 0.8)",

  "coolingConsumption": "rgb(56, 166, 219, 0.8)",

  "chargePointConsumption": "rgb(9, 202, 183, 0.8)",
  "chargePointIntermediateConsumption": "rgb(0, 162, 147, 0.8)",
  "chargePointPower": "rgb(122, 234, 219, 0.8)",

  "windSpeed": "rgb(186, 186, 186, 0.8)",
  "rainfall": "rgb(52, 52, 235, 0.8)",
  "temperature": "rgb(235, 128, 52, 0.8)",
  "heatingDegreeDays": "rgb(81, 55, 99, 0.8)",
  "sunHours": "rgb(227, 107, 2, 0.8)",
  "degreeDays": "rgb(81, 55, 99, 0.8)",
  "solarRadiation": "rgb(117, 21, 26, 0.8)",

  "co2EmissionFromElectricity": "rgb(54, 121, 255, 0.8)",
  "co2EmissionFromGas": "rgb(255, 171, 0, 0.8)",
  "co2EmissionFromCooling": "rgb(56, 166, 219, 0.8)",
  "coolingConsumptionCosts": "rgb(56, 166, 219, 0.8)",
  "co2EmissionFromHeat": "rgb(241, 81, 46, 0.8)",
  "co2EmissionFromWater": "rgb(0, 184, 217, 0.8)",

  "electricityConsumptionCosts": "rgb(54, 121, 255, 0.8)",
  "gasConsumptionCosts": "rgb(255, 171, 0, 0.8)",
  "heatConsumptionCosts": "rgb(241, 81, 46, 0.8)",
  "waterConsumptionCosts": "rgb(0, 184, 217, 0.8)"
}
